import { red } from '@material-ui/core/colors';
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';

// A custom theme for this app
const theme = responsiveFontSizes(createMuiTheme({
  transitions: {
    // So we have `transition: none;` everywhere
    create: () => 'none',
  },
  typography: {
    fontFamily: 'Rajdhani, sans-serif',
    h1: {
      fontSize: '4rem', // ~40px
      // fontWeight: 700,
    },
    h2: {
      fontSize: '3.5rem', // ~32px
      // fontWeight: 600,
    },
    h3: {
      fontSize: '2.8rem', // ~28px
      // fontWeight: 600,
    },
    h4: {
      fontSize: '2rem', // ~24px
      // fontWeight: 500,
    },
    h5: {
      fontSize: '1.5rem', // ~20px
      fontWeight: 500,
    },
    h6: {
      fontSize: '1.2rem', // ~16px
      fontWeight: 500,
    },
  },
  palette: {  
    primary: {
      main: '#ff5722',
      contrastText: '#fafafa',
    },
    secondary: {
      main: '#00B8D4',
      contrastText: '#fafafa',
    },
    grey: {
      main: '#6f6f6f',
      contrastText: '#fafafa',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
    highlight: {
      main: '#ffcc33'
    }
  },
}));

export default theme;
